import { useEffect, useState } from 'react';
import { shuffle } from 'lodash';

// Returns `items` as-is on the server and the first client render so SSR markup
// matches hydration, then swaps in a shuffled order in an effect to avoid
// `Math.random`-driven hydration mismatches.
export function useShuffledArray<T>(items: T[]): T[] {
  const [ shuffled, setShuffled ] = useState<T[]>(items);

  useEffect(() => {
    setShuffled(shuffle(items));
  }, [ items ]);

  return shuffled;
}
